import React, { PureComponent } from 'react'
import { PASSWORD_RULES, isPasswordValid } from '../utils/password_policy'

export const isNewPasswordValid = (newPassword, confirmPassword) =>
  isPasswordValid(newPassword) && newPassword === confirmPassword

export const toMessages = (value) => (Array.isArray(value) ? value : [])

export class NewPasswordFields extends PureComponent {
  constructor(props) {
    super(props)
    this.state = { touched: false }
  }

  changeHandler = (event) => {
    this.setState({ touched: true })
    this.props.onChange(event)
  }

  renderChecklistItem(id, label, passed) {
    return (
      <li id={`rule-${id}`} key={id} className={passed ? 'text-success' : 'text-danger'}>
        <i className={`fa ${passed ? 'fa-check' : 'fa-times'}`} /> {label}
      </li>
    )
  }

  renderChecklist() {
    const { newPassword, confirmPassword } = this.props
    if (!this.state.touched) {
      return null
    }
    return (
      <ul className='list-unstyled'>
        {PASSWORD_RULES.map((rule) => this.renderChecklistItem(rule.id, rule.label, rule.test(newPassword)))}
        {this.renderChecklistItem('match', 'Passwords match', newPassword === confirmPassword)}
      </ul>
    )
  }

  render() {
    const { newPassword, confirmPassword, errors } = this.props
    return (
      <div>
        <input
          id='new-password'
          name='newPassword'
          type='password'
          placeholder='New password'
          className='form-control input-md'
          value={newPassword}
          autoComplete='new-password'
          onChange={this.changeHandler}
        />
        <input
          id='confirm-password'
          name='confirmPassword'
          type='password'
          placeholder='Confirm new password'
          className='form-control input-md'
          value={confirmPassword}
          autoComplete='new-password'
          onChange={this.changeHandler}
        />
        {this.renderChecklist()}
        {toMessages(errors).map((message, index) => (
          <div key={`${index}-${message}`} className='text-danger new-password-error'>
            {message}
          </div>
        ))}
      </div>
    )
  }
}

export default NewPasswordFields
